
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthContextProvider } from './AuthContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<AuthContextProvider>
  <React.StrictMode>
    <Router>
    <App />
    </Router>
  </React.StrictMode>
</AuthContextProvider>
);